// /src/constants/constants.js

export const EXPLAINER_VIDEO_LINK =
  "https://www.youtube.com/watch?v=dCYl4E_tdZ0";
export const EXPLAINER_VIDEO_THUMBNAIL =
  "https://i.ytimg.com/vi_webp/dCYl4E_tdZ0/maxresdefault.webp";
